<template>
	<div v-for="item in items" :key="item.ID" class="columns column6">
		<div class="vacancy-block">
			<div class="image">
				<nuxt-link :to="localePath(`/${item.filename}`)" class="no-text-decoration">
					<picture>
						<source :srcset="item.overviewImageWebp" type="image/webp" />
						<source :srcset="item.overviewImage" />
						<img :src="item.overviewImage" :alt="item.overviewImageAlt" loading="lazy" />
					</picture>
				</nuxt-link>
			</div>
			<div class="content">
				<nuxt-link :to="localePath(`/${item.filename}`)" class="no-text-decoration">
					<h4>{{ item.header }}</h4>
				</nuxt-link>
				<vacancy-info :city="item.city" :locations="item.locations" :working-hours="item.workingHours" />
				<div v-parse-links class="overview-content" v-html="item.overviewContent" />
				<div>
					<nuxt-link :to="localePath(`/${item.filename}`)" class="button button-cta-variant">
						{{ $t('viewVacancy') }}
					</nuxt-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
});
const localePath = useLocalePath();
</script>

<style lang="scss" scoped>
.column6,
.vacancy-block,
.vacancy-block .content {
	display: flex;
	flex-direction: column;
}

.vacancy-block {
	margin: 50px;
	flex: 1;

	.content {
		flex: 1;

		.overview-content {
			margin-bottom: 15px;
			flex: 1;
		}
	}

	h4 {
		margin: 25px 0;
	}
}

@media (max-width: 800px) {
	.column6 {
		flex-basis: 100%;
	}
}
</style>
